import {
  DataGridPro,
  GridColDef,
  GridRenderCellParams,
} from '@mui/x-data-grid-pro'
import { formatDateMMDDYYYY, formatTime, guessUserTZ } from '../../lib/time'
import Box from '@mui/material/Box'

export const ListedTimeSheets = (props: any) => {
  const { timeSheets, limitFieldViewForKiosk } = props
  const userTZ = guessUserTZ()
  const hideFieldsForKiosk =
    limitFieldViewForKiosk !== null ? limitFieldViewForKiosk : false

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 70 },
    {
      field: 'project',
      headerName: 'Project',
      width: 130,
      valueGetter: params => {
        return params.row.project ? params.row.project.projectName : ''
      },
    },
    {
      field: 'worker',
      headerName: 'Employee ID',
      width: 100,
      valueGetter: params => {
        if (params.row.user) {
          return params.row.user.idNumber
        } else {
          return ''
        }
      },
    },
    {
      field: 'workerName',
      headerName: 'Worker Name',
      width: 100,
      valueGetter: params => {
        if (params.row.user) {
          return params.row.user.firstName + ' ' + params.row.user.lastName
        } else {
          return ''
        }
      },
    },
    {
      field: 'dateWorked',
      type: 'dateTime',
      headerName: 'Date Worked',
      valueGetter: params => {
        return formatDateMMDDYYYY(params.row.formattedTimeDurations.startTime)
      },
    },
    {
      field: 'startTimeStamp',
      type: 'dateTime',
      headerName: 'Start Time',
      valueGetter: params => {
        return formatTime(params.row.formattedTimeDurations.startTime)
      },
    },
    {
      field: 'endTimeStamp',
      type: 'dateTime',
      headerName: 'End Time',
      valueGetter: params => {
        if (!params.row.formattedTimeDurations.endTime) {
          return 'Open'
        }
        return formatTime(params.row.formattedTimeDurations.endTime)
      },
    },
    {
      field: 'regularTimeWorkedInMinutes',
      type: 'dateTime',
      headerName: 'Regular Time Worked',
      valueGetter: params => {
        if (!params.row.formattedTimeDurations.regularTimeWorked) {
          return 'Open'
        }
        return params.row.formattedTimeDurations.regularTimeWorked
      },
    },
    {
      field: 'overTimeWorkedInMinutes',
      type: 'dateTime',
      headerName: 'Overtime Worked',
      valueGetter: params => {
        if (!params.row.formattedTimeDurations.overTimeWorked) {
          return 'Open'
        }
        return params.row.formattedTimeDurations.overTimeWorked
      },
    },
    {
      field: 'doubleOverTimeWorkedInMinutes',
      type: 'dateTime',
      headerName: 'Dobletime Worked',
      valueGetter: params => {
        if (!params.row.formattedTimeDurations.doubleOverTimeWorked) {
          return 'Open'
        }
        return params.row.formattedTimeDurations.doubleOverTimeWorked
      },
    },
    {
      field: 'costCodes',
      headerName: 'Cost Codes',
      width: 350,
      editable: false,
      renderCell: (params: GridRenderCellParams<any, any, any>) => {
        return (
          <ul className='grid-list'>
            {params.row.costCodes
              ? params.row.costCodes.map((code: any, index: number) => {
                  return (
                    <li key={`costcode${index}`}>
                      {code.costCode.label}: {`${code.percentage}%`}
                    </li>
                  )
                })
              : null}
          </ul>
        )
      },
      valueFormatter: ({ value }) => {
        if (value) {
          const costCodes = value.map((code: any, index: number) => {
            return `${code.costCode.label}: ${code.percentage}%`
          })
          return costCodes.join('; ')
        }
        return ''
      },
    },
    {
      field: 'q0',
      headerName: 'Injured',
      valueGetter: params => {
        if (params.row.clockOutAnswers && params.row?.clockOutAnswers[0]) {
          return params.row?.clockOutAnswers[0]?.answer ?? params.row?.clockOutAnswers[0]?.answerText ? 'Yes' : 'No'
        } else {
          return ''
        }
      },
    },
    {
      field: 'q1',
      headerName: 'Water',
      valueGetter: params => {
        if (params.row.clockOutAnswers && params.row.clockOutAnswers[0]) {
          return params.row?.clockOutAnswers[1]?.answer ?? params.row?.clockOutAnswers[1]?.answerText ? 'Yes' : 'No'
        } else {
          return ''
        }
      },
    },
    {
      field: 'q2',
      headerName: 'Break',
      valueGetter: params => {
        if (params.row.clockOutAnswers && params.row.clockOutAnswers[0]) {
          return params.row?.clockOutAnswers[2]?.answer ?? params.row?.clockOutAnswers[2]?.answerText ? 'Yes' : 'No'
        } else {
          return ''
        }
      },
    },
    {
      field: 'q4',
      headerName: 'Issue',
      valueGetter: params => {
        if (params.row.clockOutAnswers && params.row.clockOutAnswers[0]) {
          return params.row?.clockOutAnswers[4]?.answer ?? params.row?.clockOutAnswers[3]?.answerText ? 'Yes' : 'No'
        } else {
          return ''
        }
      },
    },
    {
      field: 'q3',
      headerName: 'Lunch Break',
      valueGetter: params => {
        if (params.row.clockOutAnswers && params.row?.clockOutAnswers[0]) {
          return params.row?.clockOutAnswers[3]?.answer ?? params.row?.clockOutAnswers[4]?.answerText ? 'Yes' : 'No'
        } else {
          return ''
        }
      },
    },
  ]

  return (
    <Box sx={{ minHeight: '200px' }}>
      {timeSheets && (
        <DataGridPro
          rows={timeSheets}
          columns={columns}
          checkboxSelection={false}
          disableSelectionOnClick
          autoHeight
          autoPageSize
        />
      )}
    </Box>
  )
}
